import { mapStaffAsArray } from '@/utils/channel'

const channel = state => {
  const { staff = {} } = state.channel || {}
  const staffArray = mapStaffAsArray(staff)

  return {
    ...state.channel,
    staffArray
  }
}

export default {
  channel
}
